import { LocaleTranslationResource } from "ui/locale/i18n.types";

export function convertBlockTimestampToDateAndTime(timestamp: number): string {
    const date = new Date(timestamp / 10 ** 6);

    return date
        .toLocaleTimeString("es-ES", {
            day: "numeric",
            month: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: false,
        })
        .replace(",", "");
}

export function convert24HourTo12Hour(time24: string, showSeconds = false): string {
    const timeRegex = /^(\d{1,2}):(\d{2})(?::(\d{2}))?$/;
    const match = time24.trim().match(timeRegex);

    if (!match) {
        throw new Error(`Formato de hora inválido: ${time24}. Se espera formato HH:mm o HH:mm:ss`);
    }

    let hours = parseInt(match[1], 10);
    const minutes = match[2];
    const seconds = match[3];

    if (hours < 0 || hours > 23) {
        throw new Error(`Hora inválida: ${hours}. Debe estar entre 0 y 23`);
    }

    if (parseInt(minutes, 10) < 0 || parseInt(minutes, 10) > 59) {
        throw new Error(`Minutos inválidos: ${minutes}. Debe estar entre 0 y 59`);
    }

    const period = hours >= 12 ? "PM" : "AM";

    if (hours === 0) {
        hours = 12;
    } else if (hours > 12) {
        hours = hours - 12;
    }

    const time12 = seconds && showSeconds ? `${hours}:${minutes}:${seconds} ${period}` : `${hours}:${minutes} ${period}`;

    return time12;
}

export type Day = {
    label: string;
    value: number;
    localeLabel: LocaleTranslationResource;
};

export const days: Day[] = [
    {
        label: "Lun",
        value: 0,
        localeLabel: "monday",
    },
    {
        label: "Mar",
        value: 1,
        localeLabel: "tuesday",
    },
    {
        label: "Mie",
        value: 2,
        localeLabel: "wednesday",
    },
    {
        label: "Jue",
        value: 3,
        localeLabel: "thursday",
    },
    {
        label: "Vie",
        value: 4,
        localeLabel: "friday",
    },
    {
        label: "Sab",
        value: 5,
        localeLabel: "saturday",
    },
    {
        label: "Dom",
        value: 6,
        localeLabel: "sunday",
    },
];
